import { render, staticRenderFns } from "./JInputPop.vue?vue&type=template&id=77212fe6&scoped=true"
import script from "./JInputPop.vue?vue&type=script&lang=js"
export * from "./JInputPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77212fe6",
  null
  
)

export default component.exports